import { CurrentPayPlan } from '@ace-clublabs/common-membership-api-types';
import { useGlobalState } from '../../../state/state';
import { autopayLink } from '../../../utils/generateURL';
import { IWTButton } from '../IWTButton';
import { deleteSessionState } from '../../../state/helpers';

export const ManageAutopayIWT: React.FC = () => {
  const [memberDetails] = useGlobalState('memberDetails');

  const manageAutopayTitle =
    memberDetails?.currentBillPlan === CurrentPayPlan.ONETIME ? 'Enroll in Auto Pay' : 'Manage Auto Pay';

  const onClick = () => {
      deleteSessionState();
      window.location.assign(autopayLink(memberDetails?.sessionId || ''));
  };

  /**
   * NOTE: 
   * - Allow user to update auto pay when pending product exists
   * - PIT Knockout handled in MAP
   */

  return (
    <>
      <IWTButton title={manageAutopayTitle} id="ManageAutopayIWT" onClick={onClick} />
    </>
  );
};
